"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _toolkit = require('@reduxjs/toolkit');

var _user = require('shared/selectors/user');
var _common = require('./common');
var _time = require('shared/services/time');

 const selectMyBlobjectLastSeenTime = _toolkit.createSelector.call(void 0, 
  _common.selectBlobjectByKey,
  _user.selectCurrentUserKey,
  (blobject, userKey) => {
    if (!blobject) return _time.EPOCH

    // Pinning an unopened team chat starts my metadata with no seen time.
    return _optionalChain([blobject, 'access', _ => _.UserMetadata, 'access', _2 => _2[userKey], 'optionalAccess', _3 => _3.SeenTime]) || _time.EPOCH
  },
); exports.selectMyBlobjectLastSeenTime = selectMyBlobjectLastSeenTime
